import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomErrorHandlerService } from "../custom-error-handler.service";
import { Observable } from 'rxjs';
import { PreferenceWebhook } from "../../../models/preference-webhooks/preference-webhook.model";
import { PreferenceWebhookSerializer } from "../../../models/preference-webhooks/preference-webhook-serializer.class";

/**
 * Service to communicate with API Client Users
 */

@Injectable()
export class PreferenceWebhookService extends BaseApiService<PreferenceWebhook> {
  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      null,
      "preferencewebhooks",
      new PreferenceWebhookSerializer(),
      new CustomErrorHandlerService()
    );
  }

  getTriggers(): Observable<any> {
      return this.httpClient.get(`${this.url}/preferencewebhooks/triggers`);
  }

  test(id: string): Observable<any> {
    return this.httpClient.post(`${this.url}/preferencewebhooks/test/${id}`, {});
  }
}
